const typographyFormParamUser = {
  text: 'User Info',
  inspector: 'Inspector',
  inspectorHelperText: 'The Inspector access only allows creating services and editing actions for which they are responsible. All other creations and edits are blocked.',
};

export default typographyFormParamUser;
